import { withWidth } from "@material-ui/core";
import { css } from "emotion";
import React from "react";

const izyTabsPanelStyle = css`
  width: 100%;
  min-width: 100% !important;
  overflow-x: scroll !important;
  -webkit-overflow-scrolling: touch;
  // display: flex;
  // justify-content: flex-start;
  // align-items: center;
  white-space: nowrap;
  padding-bottom: 25px;

  &:-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background: #d8d8d8;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #212121;
    cursor: pointer;
  }

  .tab-box {
    display: inline-block;
    width: 199px;
    padding: 12px 13px;
    border: 1px solid #eeeeee;
    background-color: #ffffff;
    border-radius: 8px;
    cursor: pointer;
    margin-right: 12px;
    text-align: left;

    &:active {
      outline: none !important;
      box-shadow: 0 2px 8px 0 rgba(33, 150, 243, 0.5);
    }

    &:selected {
      outline: none !important;
      box-shadow: 0 2px 8px 0 rgba(33, 150, 243, 0.5);
    }

    &:focus {
      outline: none !important;
      box-shadow: 0 2px 8px 0 rgba(33, 150, 243, 0.5);
    }

    .tab-title {
      display: block;
      word-break: break-word !important;
      word-wrap: break-word !important;
      font-size: 12px;
      color: #757575;
      font-weight: bold;
      text-align: left;
    }

    .tab-sub-title {
      color: #2196f3;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      text-align: left;
    }
  }

  .tab-box.active {
    background-color: #2196f3;
    box-shadow: 0 2px 8px 0 rgba(33, 150, 243, 0.5);
    border: none;

    .tab-title {
      color: #ffffff;
    }

    .tab-sub-title {
      color: #ffffff;
    }
  }
`;

const IzyTabsPanel = (props) => {
  const { tabs, tabActive, onClick, showSubTittle } = props;
  return (
    <div className={izyTabsPanelStyle}>
      {tabs.map((tab, key) => {
        return (
          <button
            type="button"
            key={key}
            className={key === tabActive ? "tab-box active" : "tab-box"}
            onClick={() => onClick(key)}
            disabled={!tab.active}
          >
            <span className="tab-title font-bold">{tab.title}</span>
            {!showSubTittle ? (
              <>
                <span className="tab-sub-title font-bold">{tab.sub_title}</span>
              </>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default withWidth()(IzyTabsPanel);
